import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MeResponse, TokenPair } from '@expeditor/shared';

/**
 * Auth-store с persistence в localStorage.
 *
 * Хранит:
 * - accessToken / refreshToken — используются `apiClient` для авторизации запросов;
 * - user — кешированный профиль (что показывать в шапке без лишних запросов);
 *
 * Никаких чувствительных данных (паролей и т.п.) сюда не пишем.
 */

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: MeResponse | null;

  setTokens(pair: TokenPair): void;
  setUser(user: MeResponse | null): void;
  /** Чистит токены и user — вызывается на /logout или при невозможности рефреша. */
  clear(): void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,

      setTokens: (pair) =>
        set({ accessToken: pair.accessToken, refreshToken: pair.refreshToken }),
      setUser: (user) => set({ user }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    {
      name: 'expeditor-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
    },
  ),
);
